import { Card, CardContent, CardHeader, CardTitle } from "@rumbledirect/ui";

import { Topbar } from "@/components/layout/topbar";
import { Content } from "@/components/layout/content";
import { getUserPermissionById } from "@/pages/admin/users/permissions/lib/queries";
import { EditUserPermissionForm } from "@/pages/admin/users/permissions/components/user-permissions-edit";
import { DeleteEntityDialog } from "@/components/common/delete";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";

export default function UserPermissionEdit() {
  const params = useParams();
  const [userPermission, setUserPermission] = useState(null);

  const getUserPermission = async () => {
    const userPermission = await getUserPermissionById(params.id);
    setUserPermission(userPermission);
  };

  useEffect(() => {
    getUserPermission();
  }, [params.id]);

  return (
    <>
      <Topbar
        title="Permission"
        breadcrumb={[{ title: "Permissions", href: "/users/permissions" }]}
      />

      <Content>
        <Card>
          <CardHeader>
            <CardTitle>Permission</CardTitle>
            <DeleteEntityDialog
              id={userPermission?.id}
              entityType="users/permissions"
              redirectTo="/users/permissions"
            />
          </CardHeader>
          <CardContent>
            <EditUserPermissionForm userPermission={userPermission} />
          </CardContent>
        </Card>
      </Content>
    </>
  );
}
